import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import { TextFieldWhite } from '../../components/customStyles/form';
import { SendIcon } from '../../components/customStyles/images';
import { InputBox } from './marketingWordStyle';
import theme from '../../theme';
import { IconButton } from '@mui/material';

const EnterMessage = (props) => {
  const { currentMsg, setCurrentMsg, handleChatData, progress, productType, isMoblie, setCurrentTab } = props;

  const handleInput = (e) => {
    setCurrentMsg(e.target.value);
  }

  const handleKeyDown = (e) => {
    if (e.nativeEvent.isComposing) {
      return;
    }

    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // 防止換行

      if (currentMsg.trim() !== '') {
        handleChatData(currentMsg);
      }
    }
  }

  return (
    <>
      <InputBox sx={{ bottom: isMoblie ? 4 : 40 }}>
        <Stack variant='center-center' >
          <Box
            sx={{
              width: isMoblie ? '85%' : '50%',
              marginRight: isMoblie ? '4px' : '16px',
            }}
          >
            <TextFieldWhite
              name="message"
              placeholder="輸入訊息，或點擊按鈕開始生成"
              multiline
              maxRows={5}
              value={currentMsg}
              onChange={handleInput}
              onKeyDown={handleKeyDown}
            />
          </Box>
          {!isMoblie &&
            <Button
              variant='fill-red-shadow'
              onClick={() => {
                handleChatData(currentMsg);
                setCurrentTab(1);
              }}
              disabled={progress || !productType}
              sx={{ height: '52px' }}
            >
              開始生成
            </Button>
          }
          {isMoblie &&
            <IconButton
              variant='primary'
              onClick={() => {
                handleChatData(currentMsg);
                setCurrentTab(1);
              }}
              disabled={progress || !productType}
            >
              <SendIcon variant='md_24' />
            </IconButton>
          }
        </Stack>
      </InputBox>
    </>
  )
}

export default EnterMessage;